import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent } from "vue";
export default defineComponent({
  name: "ActivityLogs",
  components: {},
  setup: function setup() {
    return {};
  },
  mounted: function mounted() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  } // this.messages.push("there seems to be an issue");
  ,
  watch: {},
  props: {},
  data: function data() {
    return {
      // data 
    };
  },
  methods: {
    // methods
  }
});